var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Singleton } from '~/services/service.base';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { ModelCommunity } from '~/models/model.community';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
export let ServiceCommunity = class ServiceCommunity {
    currentCommunity = plainToInstance(ModelCommunity, {
        id: '17',
        cover_link: 'communities/17/78/75/1433194378.0262',
    });
    constructor() {
        makeObservable(this);
    }
    getCommunity(communityId, forPublic) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${communityId}`, {
                params: {
                    forPublic,
                },
            })
                .then(response => {
                runInAction(() => (this.currentCommunity = plainToInstance(ModelCommunity, response.data.model)));
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", typeof (_a = typeof ModelCommunity !== "undefined" && ModelCommunity) === "function" ? _a : Object)
], ServiceCommunity.prototype, "currentCommunity", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Boolean]),
    __metadata("design:returntype", void 0)
], ServiceCommunity.prototype, "getCommunity", null);
ServiceCommunity = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [])
], ServiceCommunity);
